import { render, staticRenderFns } from "./PolicyHistoryTable.vue?vue&type=template&id=67e7d74a&"
import script from "./PolicyHistoryTable.vue?vue&type=script&lang=js&"
export * from "./PolicyHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports